/* Native links, video controls and disclosures work without JavaScript. */
(() => {
 'use strict';
 if (window.DogFirstHome) return;
 window.DogFirstHome = true;
 let observer;
 const menu = () => document.querySelector('[data-df-home-menu]');
 function initSticky() {
  observer?.disconnect();
  const hero = document.querySelector('[data-df-home-hero]');
  const sticky = document.querySelector('[data-df-home-sticky]');
  if (!hero || !sticky || !('IntersectionObserver' in window)) return;
  observer = new IntersectionObserver(entries => {
   const entry = entries[0];
   const show = !entry.isIntersecting && entry.boundingClientRect.bottom <= 0;
   sticky.hidden = !show;
   document.body.classList.toggle('df-has-sticky', show);
  }, {threshold:0});
  observer.observe(hero);
 }
 document.addEventListener('click', e => {
  const current = menu();
  if (!current?.open) return;
  if (!current.contains(e.target) || e.target.closest('a')) current.open = false;
 });
 document.addEventListener('keydown', e => {
  const current = menu();
  if (e.key === 'Escape' && current?.open) {
   current.open = false;
   current.querySelector('summary')?.focus();
  }
 });
 if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initSticky); else initSticky();
 document.addEventListener('shopify:section:load', initSticky);
 document.addEventListener('shopify:section:unload', initSticky);
})();
